export const colors = {
  mainBg: "#141313",
  blue: "#2078BD",
  secondBlue: "#5ff2f9",
  bodyText: "#F2F2F2",
  red: "#FF2822",
  yellow: "#FFC805",
  secondYellow: "#FFBF44",
  gray: "#908F8F",
  green: "#38c172",
  lightGray: "#f9f9f9",
};
